import * as permissions from 'library/permissions';
import { isOptimiserActive } from 'library/optimiser';
import settings from 'settings';

const OPTIMISER_URLS = {
  dev: 'https://cro-dev.bhp.com/',
  qa: 'https://cro-qa.bhp.com/',
  // prod intentionally points at the QA optimiser host for now.
  prod: 'https://cro-qa.bhp.com/'
};

export function optimiserUrl(env) {
  return OPTIMISER_URLS[(env || '').toLowerCase()] || OPTIMISER_URLS.dev;
}

export const siteMenuConfig = [
  {
    name: 'home',
    displayName: 'Home',
    href: '/home/roster/',
    children: [
      {
        name: 'myAccount',
        displayName: 'My Account',
        icon: 'fa-user',
        href: '/home/account/',
        children: [],
        visible: () => permissions.BasicAccess()
          .hasPermissions()
      },
      {
        name: 'myRoster',
        displayName: 'My Roster',
        icon: 'fa-calendar-alt',
        href: '/home/roster/',
        children: [],
        visible: () => permissions.BasicAccess()
          .hasPermissions()
      },
      {
        name: 'action',
        displayName: 'My Actions',
        icon: 'fa-tasks',
        href: '/home/actions/',
        children: [],
        visible: () => permissions.CanViewActions()
          .hasPermissions() || permissions.BasicAccess()
          .hasPermissions()
      }
    ],
    visible: () => permissions.BasicAccess()
      .hasPermissions() || permissions.CanViewActions()
      .hasPermissions()
  },
  {
    name: 'roster',
    displayName: 'Roster',
    href: '/roster/list/',
    children: [
      {
        name: 'roster',
        displayName: 'Roster',
        icon: 'fa-calendar-alt',
        href: '/roster/list/',
        visible: () => permissions.CanViewRosters()
          .hasPermissions(),
        children: [
          '/roster/detail/',
          '/roster/publish/'
        ]
      },
      {
        name: 'templates',
        displayName: 'Templates',
        icon: 'fa-clone',
        href: '/roster/templates/',
        visible: () => permissions.CanViewActivities()
          .hasPermissions(),
        children: [
          '/roster/templates/timeline/'
        ]
      },
      {
        name: 'activities',
        displayName: 'Activities',
        icon: 'fa-tasks',
        href: '/roster/activities/',
        visible: () => permissions.CanViewActivities()
          .hasPermissions(),
        children: []
      },
      {
        name: 'activityTypes',
        displayName: 'Activity Types',
        icon: 'fa-folder-open',
        href: '/roster/activityTypes/',
        visible: () => permissions.CanAdminActivities()
          .hasPermissions(),
        children: []
      },
      {
        name: 'validations',
        displayName: 'Validations',
        icon: 'fa-calendar-check',
        href: '/roster/validations/',
        visible: () => permissions.CanAdminRosters()
          .hasPermissions(),
        children: []
      },
      {
        name: 'rosterBuilder',
        displayName: 'Roster Builder',
        icon: 'fa-calendar-alt',
        href: '/roster/rosterBuilders/',
        visible: () => permissions.CanViewActivities()
          .hasPermissions(),
        children: [
          '/roster/rosterBuilders/timeline/'
        ]
      },
      {
        name: 'optimiser',
        displayName: 'Optimiser',
        href: '/roster/optimiser/',
        externalHref: optimiserUrl(settings.APP_CONFIG.environment),
        visible: () => isOptimiserActive(),
        children: []
      }
    ],
    visible: () => permissions.CanViewRosters()
      .hasPermissions() || permissions.CanViewActivities()
      .hasPermissions()
  },
  {
    name: 'travel',
    displayName: 'Travel',
    href: '/travel/itineraries/',
    children: [
      {
        name: 'itineraries',
        displayName: 'Itineraries',
        icon: 'fa-suitcase',
        href: '/travel/itineraries/',
        visible: () => permissions.CanViewTravel()
          .hasPermissions(),
        children: []
      },
      {
        name: 'legs',
        displayName: 'Legs',
        icon: 'fa-plane',
        href: '/travel/legs/',
        visible: () => permissions.CanViewTravel()
          .hasPermissions(),
        children: []
      },
      {
        name: 'routes',
        displayName: 'Routes',
        icon: 'fa-compass',
        href: '/travel/routes/',
        visible: () => permissions.CanViewTravel()
          .hasPermissions(),
        children: []
      },
      {
        name: 'locations',
        displayName: 'Locations',
        icon: 'fa-globe-asia',
        href: '/travel/locations/',
        visible: () => permissions.CanViewTravel()
          .hasPermissions(),
        children: []
      }
    ],
    visible: () => permissions.CanViewTravel()
      .hasPermissions()
  },
  {
    name: 'availability',
    displayName: 'Availability',
    href: '/availability/leave/',
    children: [
      {
        name: 'cycles',
        displayName: 'Cycles',
        icon: 'fa-sync-alt',
        href: '/availability/cycles',
        children: [],
        visible: () => permissions.CanViewAvailability()
          .hasPermissions()
      },
      {
        name: 'legs',
        displayName: 'Legs',
        icon: 'fa-business-time',
        href: '/availability/legs',
        children: [],
        visible: () => permissions.CanViewAvailability()
          .hasPermissions()
      },
      {
        name: 'legTypes',
        displayName: 'Leg Types',
        icon: 'fa-folder-open',
        href: '/availability/legTypes/',
        children: [],
        visible: () => permissions.CanViewAvailability()
          .hasPermissions()
      },
      {
        name: 'leave',
        displayName: 'Leave',
        icon: 'fa-umbrella-beach',
        href: '/availability/leave/',
        visible: () => false,
        children: []
      },
      {
        name: 'leaveTypes',
        displayName: 'Leave Types',
        icon: 'fa-folder-open',
        href: '/availability/leaveTypes/',
        visible: () => permissions.CanViewAvailabilities()
          .hasPermissions(),
        children: []
      },
      {
        name: 'leaveStatus',
        displayName: 'Leave Status',
        icon: 'fa-check',
        href: '/availability/leaveStatus/',
        visible: () => permissions.CanViewAvailabilities()
          .hasPermissions(),
        children: []
      }
    ],
    visible: () => permissions.CanViewAvailabilities()
      .hasPermissions()
  },
  {
    name: 'manage',
    displayName: 'Manage',
    href: '/manage/users/',
    children: [
      {
        name: 'users',
        displayName: 'Users',
        icon: 'fa-users',
        href: '/manage/users/',
        children: ['/manage/optimiser-status/'],
        visible: () => permissions.CanViewUsers()
          .hasPermissions()
      },
      {
        name: 'competency',
        displayName: 'Competencies',
        icon: 'fa-university',
        href: '/manage/competencies/',
        children: [],
        visible: () => permissions.CanViewCompetencies()
          .hasPermissions()
      },
      {
        name: 'competencyType',
        displayName: 'Competency Types',
        icon: 'fa-folder-open',
        href: '/manage/competencyTypes/',
        children: [],
        visible: () => permissions.CanViewCompetencies()
          .hasPermissions()
      },
      {
        name: 'actionType',
        displayName: 'Action Types',
        icon: 'fa-folder-open',
        href: '/manage/actionTypes/',
        children: [],
        visible: () => permissions.CanViewActions()
          .hasPermissions()
      },
      {
        name: 'tags',
        displayName: 'Tags',
        icon: 'fa-tags',
        href: '/manage/tags/',
        children: [],
        visible: () => permissions.CanViewTags()
          .hasPermissions()
      }
    ],
    visible: () => permissions.CanViewUsers()
      .hasPermissions() || permissions.CanViewCompetencies()
      .hasPermissions() || permissions.CanViewTags()
      .hasPermissions()
  },
  {
    name: 'reports',
    displayName: 'Reports',
    href: '/reports/dashboard/',
    children: [{
      name: 'dashboard',
      displayName: 'Dashboard',
      icon: 'fa-chart-pie',
      href: '/reports/dashboard/',
      children: [],
      visible: () => permissions.CanViewReports()
        .hasPermissions()
    }],
    visible: () => permissions.CanViewReports()
      .hasPermissions()
  }
];

export const timelineContextConfig = (readonly = [], exclude = [], include = []) => [
  {
    title: 'Edit',
    icon: 'edit',
    task: 'edit',
    disabled: () => readonly.includes('edit') || !permissions.CanAdminRosters()
      .hasPermissions()
  },
  {
    title: 'Edit Selected',
    icon: 'reconciliation',
    task: 'editselected',
    disabled: () => readonly.includes('editselected') || !permissions.CanAdminRosters()
      .hasPermissions()
  },
  {
    // Shown only when ItemRenderer includes it (OT assignments); ItemRenderer also sets
    // its title, disabled state and tooltip from the selection.
    title: 'Set OT availability…',
    icon: 'clock-circle',
    task: 'availablesignon',
    optional: true,
    disabled: () => readonly.includes('availablesignon') || !permissions.CanAdminRosters()
      .hasPermissions()
  },
  {
    title: 'Reassign',
    icon: 'user',
    task: 'reassign',
    disabled: () => readonly.includes('reassign') || !permissions.CanAdminRosters()
      .hasPermissions()
  },
  {
    title: 'New Action',
    icon: 'bars',
    task: 'action',
    disabled: () => readonly.includes('action') || !permissions.BasicAccess()
      .hasPermissions()
  },
  {
    title: 'Add/Edit Notes',
    icon: 'edit',
    task: 'travel',
    disabled: () => readonly.includes('travel') || !permissions.CanAdminRosters()
      .hasPermissions()
  },
  {
    title: 'Copy',
    icon: 'copy',
    task: 'copy',
    disabled: () => readonly.includes('copy') || !permissions.CanAdminRosters()
      .hasPermissions()
  }
].filter(i => !exclude.includes(i.task) && (!i.optional || include.includes(i.task)));
